export const GET_EXPENSES_REQUEST = "GET_EXPENSES_REQUEST";
export const GET_EXPENSES_SUCCESS = "GET_EXPENSES_SUCCESS";
export const GET_EXPENSES_FAILURE = "GET_EXPENSES_FAILURE";
export const GET_EXPENSES_PENDING = "GET_EXPENSES_PENDING";
